import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Hyperlink } from '../../../../objects';
import { CalendarItemService } from '../../services/calendar-item.service';
import { CalendarItemHyperlinkService } from '../../services/calendar-item-hyperlink.service';
 

@Component({
  selector: 'app-calendar-item-edit-urls-detail',
  templateUrl: './calendar-item-edit-urls-detail.component.html',
  styleUrls: ['./calendar-item-edit-urls-detail.component.css']
})
export class CalendarItemEditUrlsDetailComponent implements OnInit {

  public isEdit: boolean;
  @Input() public link: Hyperlink
  @Input() public calendarItemId: string
  @Output() public linksUpdated: EventEmitter<void> = new EventEmitter();

  public linkModelToEdit: Hyperlink

  constructor(public calendarItemHyperLinkSvc: CalendarItemHyperlinkService) { }

  ngOnInit() {
    this.isEdit = false;
 
    if (this.link == undefined) {
      
      this.link = new Hyperlink();
      this.link.AnchorText = "";
      this.link.Description = "";
      this.link.Url = "";
      this.edit();
    }

  }

  public edit() {
    this.isEdit = true;
    this.linkModelToEdit = this.link;
  }

  public save() {
    
    if (this.calendarItemId == null) {
      alert("CalendarItemId is undefined");
      return;
    }

    console.log("Saving", this.linkModelToEdit, this.calendarItemId);

    this.calendarItemHyperLinkSvc.save(this.linkModelToEdit, this.calendarItemId).then(
      (data) => { 
         console.log("DONE", data);
         this.isEdit = false; 

         this.linksUpdated.emit();
      }
    ).catch(
      (err) => {
        alert("There was an error while saving this URL");
        console.log(err);
        this.isEdit = false; 
      }
    )
  }

  public delete() {
    
    if (confirm("Delete this link?")) {
      this.calendarItemHyperLinkSvc.delete(this.link.Id).then(
        () => { 
           console.log("LINK DELETED");
           this.isEdit = false; 
           this.linksUpdated.emit();
        }
      ).catch(
        (err) => {
          alert("There was an error while deleting this URL");
          console.log(err);
          this.isEdit = false; 
        }
      )
    }

  }

}
